import { TableActions } from "../../components/tables/tableContext/TableContext";
import TableWidget from "../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  getTransferTasksTableData,
  transferTasksTableHeader,
} from "./components/tableConfigs/transferTableConfig";
import { getTransferTasks } from "../../redux/api/receipt.api";

function TransferTasks() {
  const dispatch = useAppDispatch();

  const {
    receipt: {
      transferTasks: { data, isLoadingTransferTasks },
    },
  } = useAppSelector((state) => ({
    receipt: state.receipt,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        getTransferTasks({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          status: action.tableSearch?.status ?? 1,
          type: action.tableSearch?.type ?? 1,
        }),
      );
    }
  };

  return (
    <div>
      <TableWidget
        tableTitle={"Taskuri de transfer marfa catre depozitul de vanzare"}
        tableHeaderData={transferTasksTableHeader}
        tableItemsData={getTransferTasksTableData(data.taskuriTransfer)}
        totalItems={data.nrTotalTaskuriTransfer}
        tableLoading={isLoadingTransferTasks}
        handleTableActions={handleTableActions}
        withGlobalSearch={false}
        withGlobalFilter={false}
        withTablePagination
      />
    </div>
  );
}

export default TransferTasks;
